import config from '@/modules/config/functions/config';
import type { InitOptions } from 'i18next';

export default {
  interpolation: {
    escapeValue: false,
  },
  react: {
    defaultTransParent: 'span',
    transWrapTextNodes: 'span',
  },
  detection: {
    order: ['querystring', 'localStorage', 'navigator'],
    lookupQuerystring: config('i18n.languageLookupQuerystringKey', 'lang'),
    lookupLocalStorage: config(
      'i18n.languageLookupLocalStorageKey',
      'i18n:language'
    ),
  },
} as InitOptions;
